import { useMemo } from "react";
import { TaskGrid } from "../../components/TaskGrid/TaskGrid";
import { useBoardViews } from "../../contexts/views/viewsContext";
import ViewTitle from "../../layout/components/ViewTitle";
import Enums from "../../types/enums";

export const CompletedTasks = () => {
  const { systemViews } = useBoardViews();

  const completedView = useMemo(
    () => systemViews.find((v) => v.ViewType === Enums.ViewType.CompletedTasks),
    [systemViews]
  );

  return (
    <>
      <div className="row">
        <ViewTitle viewId={completedView?.Id} viewName={completedView.Name} />
      </div>
      <div className="row">
        <TaskGrid
          viewId={completedView?.Id}
          viewType={Enums.ViewType.CompletedTasks}
        />
      </div>
    </>
  );
};
